'use strict';

function resizeWindow() {
	setTimeout(function () {
		equalize();
	}, 500);
}
function scrollDown() {}

$(document).ready(function () {

	$(".overlay-nav").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="third-nav" role="navigation" aria-labelledby="third-nav">', '<nav id="third-nav" role="navigation">');
	});
	$(".overlay-nav").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<ul id="privary-navigation">', '<ul id="privary-navigation-overlay-nav">');
	});
	$(".overlay-nav").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="primary-nav" role="navigation">', '<nav id="primary-nav-overlay-nav" role="navigation">');
	});

	$("#footer").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="third-nav" role="navigation" aria-labelledby="third-nav">', '<nav id="third-nav-footer" role="navigation">');
	});
	$("#footer").html(function (buscayreemplaza, reemplaza) {
		return reemplaza.replace('<ul id="tertiary-navigation">', '<ul id="tertiary-navigation-footer">');
	});

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 40) {
			$('.arrow-home').fadeOut();
		} else {
			$('.arrow-home').fadeIn();
		}
	});

	// Menu
	$(".menu-trigger").click(function () {
		$(".overlay-nav").fadeToggle(200);
	});
	$('.close-btn-menu').on('click', function () {
		$(".overlay-nav").fadeToggle(200);
		//$(".button a").toggleClass('btn-open').toggleClass('btn-close');
		open = false;
	});
	// Booking
	$(".book-trigger").click(function () {
		$(".overlay-book").fadeToggle(200);
		$('.all-offers').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			accessibility: false,
			fade: false,
			cssEase: 'linear'
		});
	});
	$('.close-btn-book').on('click', function () {
		$(".overlay-book").fadeToggle(200);
		open = false;
	});
	$('.offer').click(function () {
		if ($(this).children('.checkbox').hasClass('active')) {
			$(this).children('.checkbox').removeClass('active');
			$('input[name=promo]').val('');
		} else {
			$('.offer .checkbox').removeClass('active');
			$(this).children('.checkbox').addClass('active');
			$('input[name=promo]').val($(this).attr('attr-value'));
		}
	});

	// booking info when over
	$(".container-reserve").hover(function () {
		$(".best-rate-list").fadeToggle();
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() }, 800, 'easeOutExpo');
	});

	//Slick Slider
	$('.sym-slides').slick();

	$(".all-reasons").slick({
		arrows: true,
		autoplay: false,
		dots: true,
		fade: true,
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('slick-index') + 1;
			return '<a>' + 0 + title + '</a>';
		}
	});

	$(".all-rooms").slick({
		arrows: false,
		autoplay: false,
		dots: true,
		fade: true,
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return '<a>' + title + '</a>';
		}
	});

	// The function actually applying the offset
	function offsetAnchor() {
		if (location.hash.length !== 0) {
			window.scrollTo(window.scrollX, window.scrollY - 350);
		}
	}

	// This will capture hash changes while on the page
	$(window).on("hashchange", offsetAnchor);

	// This is here so that when you enter the page with a hash,
	// it can provide the offset in that case too. Having a timeout
	// seems necessary to allow the browser to jump to the anchor first.
	window.setTimeout(offsetAnchor, 1);

	/*** Home Page Map ***/
	$('#home .home-map ul.pins li').click(function () {
		$('#home .home-map ul.pins li').removeClass('active');
		$(this).addClass('active');
		$('.each-location').hide();
		$('#each-location' + $(this).attr('target')).fadeIn();
	});

	$('.each-side').hover(function () {
		$(this).children(".full-copy").stop(true, true).slideDown(400);
		$(this).children(".full-copy").find('p').delay(100).animate({
			opacity: 1,
			marginTop: 50 + "px"
		}, 400);
	}, function () {
		$(this).children(".full-copy").stop(true, true).delay(10).slideUp(400);
		$(this).children(".full-copy").find('p').animate({
			opacity: 0,
			marginTop: 0 + "px"
		}, 400);
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '.' + 'd' + '.' + 'y',
		altField: "#check_in_alt",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '.' + 'd' + '.' + 'y',
		altField: "#check_out_alt",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut-2").datepicker("setDate", newDate);
			$("#CheckOut-2").datepicker("option", "minDate", selectedDate);
		}
	});
	//Check in and check out datepicker for booking engine Black

	$("#black-CheckIn-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2017, 10, 24),

		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#black-CheckOut-2").datepicker("setDate", newDate);
			$("#black-CheckOut-2").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#black-CheckOut-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2017, 10, 24),

		onSelect: function onSelect(selectedDate) {
			$("#black-CheckIn-2").datepicker("option", "maxDate", selectedDate);
		}
	});
	$("#black-CheckIn-3").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2017, 10, 24),

		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#black-CheckOut-3").datepicker("setDate", newDate);
			$("#black-CheckOut-3").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#black-CheckOut-3").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2017, 10, 24),

		onSelect: function onSelect(selectedDate) {
			$("#black-CheckIn-3").datepicker("option", "maxDate", selectedDate);
		}
	});

	$("#CheckOut-2").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn-2").datepicker("option", "maxDate", selectedDate);
		}
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn-3").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut-3").datepicker("setDate", newDate);
			$("#CheckOut-3").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut-3").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn-3").datepicker("option", "maxDate", selectedDate);
		}
	});
	//Check in and check out datepicker for booking engine
	$("#CheckIn_header").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '.' + 'd' + '.' + 'y',
		altField: "#check_in_alt_header",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut_header").datepicker("setDate", newDate);
			$("#CheckOut_header").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut_header").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '.' + 'd' + '.' + 'y',
		altField: "#check_out_alt_header",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn_header").datepicker("option", "maxDate", selectedDate);
		}
	});
});